export default {
  massRemove: 'Supprimer les connecteurs surveillés pour anomalies',
  massEnable: 'Activer les connecteurs surveillés pour anomalies',
  massDisable: 'Désactiver les connecteurs surveillés pour anomalies',
};
